"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = exports.findLevelLogger = void 0;
const lodash_1 = require("lodash");
const format = (message, data) => typeof (message) === 'function' ? message(data) : message;
const findLevelLogger = (level, logger) => {
    switch (level) {
        case 'warn':
            return logger.warn;
        case 'error':
            return logger.error;
        case 'info':
        default:
            return logger.error;
    }
};
exports.findLevelLogger = findLevelLogger;
const createLogger = ({ info, error, warn } = { info: console.log, error: console.error, warn: console.warn }, data) => ({
    info: (type, message, extra) => {
        const args = (0, lodash_1.merge)({}, { type }, data, extra);
        info(format(message, args), args);
    },
    error: (type, message, extra) => {
        const args = (0, lodash_1.merge)({}, { type }, data, extra);
        error(format(message, args), args);
    },
    warn: (type, message, extra) => {
        const args = (0, lodash_1.merge)({}, { type }, data, extra);
        warn(format(message, args), args);
    },
    context: () => data,
    extend: (extra) => (0, exports.createLogger)({ info, error, warn }, (0, lodash_1.merge)({}, data, typeof (extra) === 'function'
        ? extra((0, lodash_1.merge)({}, data))
        : extra))
});
exports.createLogger = createLogger;
//# sourceMappingURL=logger.js.map